import { Crosshair } from "lucide-react";

const items = [
  "K9 Compound Patrols",
  "CCTV Surveillance Matrix",
  "Biometric Key Fob Access",
  "24/7 Rapid Alarm Response",
  "Executive Risk Consulting",
  "Static Guard Placement",
  "Mobile Patrol Division",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section data-testid="editorial-marquee" className="border-y border-white/10 bg-[#0F1115] overflow-hidden py-5">
      <div className="marquee-track flex items-center gap-10 w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-mono text-sm uppercase tracking-[0.3em] text-gray-500 whitespace-nowrap">
            {item}
            <Crosshair className="w-4 h-4 text-blue-500/70" />
          </span>
        ))}
      </div>
    </section>
  );
}
